import { render, staticRenderFns } from "./PlanIcons.vue?vue&type=template&id=2fec8a87&"
import script from "./PlanIcons.vue?vue&type=script&lang=js&"
export * from "./PlanIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports